export function addCurrent(holiday) {
    return {
        type: 'ADD_CURRENT',
        holiday,
    }
}
